import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { useClient } from '../../client-api';
import { getSurplusEntries, type SurplusPanelSettingsDto } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useSurplusSettings(enabled = true): UseQueryResult<SurplusPanelSettingsDto, AxiosError> {
    const { data: client } = useClient();
    const queryKey = useMemo(() => queryKeys.surplusPanelSettings(client?.partnerUuid), [client?.partnerUuid]);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => getSurplusEntries({ query: { clientId: client!.id }, signal }).then((result) => result.data),
        enabled: !!client && enabled,
    });
}
